var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 20,
    height: 20,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_24",
    "data-name": "Mask Group 24",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0.348 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M21.018,11.353H14.642V10.232L18.824,4.2V4.111H14.755V2.705h6.139V3.826L16.73,9.859v.088h4.29v1.406Z",
    transform: "translate(-2.432 -2.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M16.351,20.482l-.678,2.223H13.944l2.9-8.647h2l2.888,8.647H19.919l-.68-2.223H16.351ZM18.9,19.209l-1.057-3.5h-.076l-1.057,3.5Z",
    transform: "translate(-2.432 -2.705)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M7.3,21.894a.811.811,0,1,1-1.622,0V6.012L3.818,7.872A.812.812,0,1,1,2.669,6.724L5.913,3.482l.011-.011a.808.808,0,0,1,1.135.01L10.3,6.724A.811.811,0,1,1,9.157,7.872L7.3,6.012Z",
    transform: "translate(-2.432 -2.705)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZA);
export default __webpack_public_path__ + "static/media/z-a.6aca7d719a78093d1e21edebe869039c.svg";
export { ForwardRef as ReactComponent };